import { Row, Col, Skeleton, Tooltip,message } from "antd";
import { RiUserSearchFill } from "react-icons/ri";
import axios from "axios";
import classes from "../Pages.module.css";
import { useState, useEffect, useContext } from "react";
import DataContext from "../../../Context/dataContext";
import EmployeeTable from "../EmployeeTable/EmployeeTable";
import { AiFillDelete } from "react-icons/ai";
import {  getFormPermissions } from '../../../utils/checkDayPermission';

import { Link } from "react-router-dom";

const WeightBridgeDetail = (props) => {
  const employeeData = useContext(DataContext);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState(null);
  const [drows, setDRows] = useState(null);
  const { canAdd, canModify, canDelete, canQuery, messages } = getFormPermissions("Weighbridge", employeeData);

  useEffect(() => {
    setDRows(null);
    setRows(null);
    setColumns([]);

    axios
      .get(employeeData.URL + "/api/v1/weighbridge", {
        withCredentials: true,
      })
      .then((response) => {
        // console.log(response);

        setColumns((columns) => {
          let newCols = response.data.data.Bev.fields.map((col) => {
            return {
              name: col.name,
              title: col.name.split("_").join(" ").toLowerCase(),
            };
          });

          const newNewCols = [
            { name: "D", title: "D" },
            { name: "V", title: "V" },
            { name: "SNO", title: "SNo" },
            ...newCols,
          ];
          return newNewCols;
        });

        setRows((rows) => {
          let newRows = response.data.data.Bev.rows.map((row, index) => {
            return {
              D:canDelete ? (
                <Tooltip placement="bottom" title="Delete" color="red">
                  <Link to="#" style={{ color: "red", fontWeight: "bolder" }}>
                    <AiFillDelete
                      onClick={(event) =>
                        deleteHandler(
                          event,
                          index,
                          response.data.data.Bev.rows,
                          row["wt_code"]
                        )
                      }
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ): (
                <Tooltip 
                  placement="bottom" 
                  title={messages.delete}
                  color="red"
                >
                  <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                    <AiFillDelete
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </span>
                </Tooltip>
              ),
              V:canModify ? (
                <Tooltip placement="bottom" title="View" color="#1777C4">
                  <Link
                    to={
                      "/gate/transaction/weighbridge-form-view/" +
                      row["wt_code"]
                    }
                    style={{ color: "#1777C4", fontWeight: "bolder" }}
                  >
                    <RiUserSearchFill
                      style={{
                        color: "#1777C4",
                        fontWeight: "bolder",
                        fontSize: "0.9rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ): (
                <Tooltip 
                  placement="bottom" 
                  title={messages.query}
                  color="#1777C4"
                >
                  <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                    <RiUserSearchFill
                      style={{
                        color: "#1777C4",
                        fontWeight: "bolder",
                        fontSize: "0.9rem",
                      }}
                    />
                  </span>
                </Tooltip>
              ),

              SNO: index + 1,
              ...row,
            };
          });
          return newRows;
        });
      })
      .catch((error) => {
        // console.log(error);
      });
  }, [employeeData, canDelete, canQuery]);

  const deleteHandler = (event, index, newrows, code) => {
    // console.log(index);
    if (!canDelete) {
      message.warning(messages.delete || "You don't have permission to delete items.");
      return;
    }
    // console.log(index);

    setRows(null);
    axios
      .delete(employeeData.URL + "/api/v1/weighbridge/" + code.toString(), {
        withCredentials: true,
      })
      .then((response) => {
        // console.log(response);
        const rowvals = newrows.filter((row) => row["wt_code"] !== code);
        setRows((rows) => {
          let newDRows = rowvals.map((row, index) => {
            return {
              D:canDelete ? (
                <Tooltip placement="bottom" title="Delete" color="red">
                  <Link to="#" style={{ color: "red", fontWeight: "bolder" }}>
                    <AiFillDelete
                      onClick={(event) =>
                        deleteHandler(event, index, rowvals, row["wt_code"])
                      }
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ): (
                <Tooltip 
                  placement="bottom" 
                  title={messages.delete}
                  color="red"
                >
                  <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                    <AiFillDelete
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </span>
                </Tooltip>
              ),
              V:canModify ? (
                <Tooltip placement="bottom" title="View" color="#1777C4">
                  <Link
                    to={
                      "/gate/transaction/weighbridge-form-view/" +
                      row["wt_code"]
                    }
                    style={{ color: "#1777C4", fontWeight: "bolder" }}
                  >
                    <RiUserSearchFill
                      style={{
                        color: "#1777C4",
                        fontWeight: "bolder",
                        fontSize: "0.9rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ): (
                <Tooltip 
                  placement="bottom" 
                  title="You don't have permission to view items" 
                  color="#1777C4"
                >
                  <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                    <RiUserSearchFill
                      style={{
                        color: "#1777C4",
                        fontWeight: "bolder",
                        fontSize: "0.9rem",
                      }}
                    />
                  </span>
                </Tooltip>
              ),

              SNO: index + 1,
              ...row,
            };
          });
          return newDRows;
        });
      })
      .catch((error) => {
        setRows((rows) => {
          let newDRows = newrows.map((row, index) => {
            return {
              D:canDelete ?(
                <Tooltip placement="bottom" title="Delete" color="red">
                  <Link to="#" style={{ color: "red", fontWeight: "bolder" }}>
                    <AiFillDelete
                      onClick={(event) =>
                        deleteHandler(event, index, newrows, row["wt_code"])
                      }
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ): (
                <Tooltip 
                  placement="bottom" 
                  title={messages.delete}
                  color="red"
                >
                  <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                    <AiFillDelete
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </span>
                </Tooltip>
              ),
              V:canModify ?  (
                <Tooltip placement="bottom" title="View" color="#1777C4">
                  <Link
                    to={
                      "/gate/transaction/weighbridge-form-view/" +
                      row["wt_code"]
                    }
                    style={{ color: "#1777C4", fontWeight: "bolder" }}
                  >
                    <RiUserSearchFill
                      style={{
                        color: "#1777C4",
                        fontWeight: "bolder",
                        fontSize: "0.9rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ): (
                <Tooltip 
                  placement="bottom" 
                  title="You don't have permission to view items" 
                  color="#1777C4"
                >
                  <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                    <RiUserSearchFill
                      style={{
                        color: "#1777C4",
                        fontWeight: "bolder",
                        fontSize: "0.9rem",
                      }}
                    />
                  </span>
                </Tooltip>
              ),

              SNO: index + 1,
              ...row,
            };
          });
          return newDRows;
        });
        // console.log(error);
      });
  };

  return (
    <>
      <Row className={classes["Row"]}>
        <Col md={14}>
          <p className={classes["Title"]}>Weighbridge Details</p>
        </Col>
        <Col className={classes["Col"]} md={10}></Col>
      </Row>
      <p></p>
      <Row className={classes["Row"]}>
        <Col lg={19} md={17}></Col>
        <Col className={classes["Col"]} lg={5} md={7}>
          <Link to={canAdd ?"/gate/transaction/weighbridge-create":"#"}
          onClick={(e) => !canAdd && e.preventDefault()}>
            <button
              disabled={!canAdd}
              style={{
                opacity: canAdd ? 1 : 0.5,
                cursor: canAdd ? 'pointer' : 'not-allowed'
              }}
              className={classes["ProfileButton"]}
            >
              <strong>Add Weighbridge</strong>{" "}
            </button>
          </Link>
        </Col>
      </Row>
      <p></p>
      {rows && columns.length > 0 ? (
        <>
          <EmployeeTable data={rows} columns={columns} val={true} />
        </>
      ) : (
        <>
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
        </>
      )}
    </>
  );
};

export default WeightBridgeDetail;
